import { render, staticRenderFns } from "./MedicosSolicitantes.vue?vue&type=template&id=ba97f97e"
import script from "./MedicosSolicitantes.vue?vue&type=script&lang=js"
export * from "./MedicosSolicitantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports